import gql from 'graphql-tag';
import { findIndex } from 'lodash';
import apollo from 'src/features/apolloSecure';

const query = gql`
query GetChannels {
  channels {
    id
    name
    type
    priority
    identifier
    group {
      id
      name
      description
    }
    teams {
      id
      name
    }
    allTeamsOn
    requestTypePriorities {
      id
      weight
      requestType{
        id
        name
        active
      }
    }
    config
  }
}`;

const queryGroup = gql`
query GetChannelsGroups {
  channelsGroups {
    id
    name
    description
  }
}`;

export function parseConfig(configStr) {
  if (!configStr) return [];
  const configObj = JSON.parse(configStr);
  return Object.keys(configObj).map((name) => ({
    name,
    value: configObj[name],
  }));
}

export function parseChannel(channel) {
  const config = JSON.parse(channel.config);
  return {
    id: channel.id,
    name: channel.channel.identifier,
    fields: Object.keys(config).map((name) => ({
      name,
      value: config[name],
    })),
  };
}

function getChannels() {
  return Promise.all([
    apollo.client.query({
      query,
      fetchPolicy: 'network-only',
    }).then((res) => res.data.channels)
      .then((channels) => channels.map((channel) => ({
        ...channel,
        fields: parseConfig(channel.config),
      }))),
    apollo.client.query({
      query: queryGroup,
      fetchPolicy: 'network-only',
    }).then((res) => res.data.channelsGroups),
  ])
    .then(([models, groups]) => [models.map((model) => {
      const group = groups[findIndex(groups, { id: model.group.id })];
      return { ...model, group };
    }), groups]);
}

export default getChannels;
